import {
  useMutation,
  useQuery,
  useQueryClient,
  useInfiniteQuery
} from "@tanstack/react-query"

import client from "utils/client"
import { getNextPageParam } from "shared/lib/ransack"

export const useBillingAddresses = (customerId, params = {}) => {
  return useInfiniteQuery({
    queryKey: [
      "v2",
      "jap_customers",
      customerId,
      "billing_addresses",
      "index",
      params
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await client.get(
        `/v2/jap_customers/${customerId}/billing_addresses.json`,
        {
          params: { ...params, page: pageParam }
        }
      )
      return res.data
    },
    getNextPageParam
  })
}

export const useBillingAddress = (id, customerId) => {
  return useQuery({
    queryKey: [
      "v2",
      "jap_customers",
      customerId,
      "billing_addresses",
      "show",
      id
    ],
    queryFn: async () => {
      const res = await client(
        `/v2/jap_customers/${customerId}/billing_addresses/${id}.json`
      )
      return res.data
    },
    enabled: !!id
  })
}

export const useCreateBillingAddress = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ values, customerId }) => {
      const response = await client.post(
        `/v2/jap_customers/${customerId}/billing_addresses.json`,
        {
          billing_address: values
        }
      )

      return response.data
    },
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries({
        queryKey: ["v2", "jap_customers", customerId, "billing_addresses"]
      })
    }
  })
}

export const useUpdateBillingAddress = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, customerId, values }) => {
      const response = await client.put(
        `/v2/jap_customers/${customerId}/billing_addresses/${id}.json`,
        {
          billing_address: values
        }
      )

      return response.data
    },
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries({
        queryKey: ["v2", "jap_customers", customerId, "billing_addresses"]
      })
      queryClient.removeQueries({
        queryKey: [
          "v2",
          "jap_customers",
          customerId,
          "billing_addresses",
          "show"
        ]
      })
    }
  })
}

export const useDeleteBillingAddress = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, customerId }) => {
      const response = await client.delete(
        `/v2/jap_customers/${customerId}/billing_addresses/${id}.json`
      )

      return response.data
    },
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries({
        queryKey: ["v2", "jap_customers", customerId, "billing_addresses"]
      })
    }
  })
}
